/**
 * Created by Ning Jiang on 2021-06-22.
 */

import {StageLayer} from "@nolimitcity/slot-launcher/bin/StageLayer";
import {gsap, TimelineLite} from "gsap";
import {DevilsCrossRoadLayers, Layers} from "../../../view/DevilsCrossRoadLayers";
import {DevilsCrossRoad} from "../../../DevilsCrossRoad";
import {NolimitApplication} from "@nolimitcity/slot-launcher/bin/NolimitApplication";
import {DevilsCrossRoadSound} from "../../../sound/DevilsCrossRoadSound";

export class BigWinView extends PIXI.Container{

    private _layer: StageLayer;
    private _bigwinSpineMap: Map<number, PIXI.spine.Spine> = new Map();
    private _overlay:PIXI.Graphics;

    constructor() {
        super();
        this._layer = DevilsCrossRoadLayers.getLayer(Layers.BIG_WIN)!;
        this.init();
        this.onResize();
        this._layer.addChild(this);
    }

    public getLevelAnimation(level: number, duration: number, isEndLevel: boolean): TimelineLite {
        const tl = gsap.timeline();
        level += 1;
        let spine: PIXI.spine.Spine | undefined = this._bigwinSpineMap.get(level);


        tl.add(() => {
            this._overlay.visible=true;
            if (spine) {
                spine.visible = true;
                spine.state.timeScale = 1;
                spine.state.setAnimation(0, `BW${level}`, false);
            }
        }, 0);
        tl.to(this, {duration: duration});
        tl.add(() => {
            if (spine) {
                spine.visible = false;
            }
        }, isEndLevel?duration+0.2:duration);
        return tl;
    }

    public playEnding(endLevel: number): void {
        // TODO:
        this.resetBigwinAnim();
        this._overlay.visible=false;
    }

    private init(): void {
        this.createOverlay();
        for (let level: number = 1; level <= 5; level++) {
            this._bigwinSpineMap.set(level, this.createLevelSpine(level));
        }
    }

    private createLevelSpine(level: number): PIXI.spine.Spine {
        let spineName: string = "BW" + level;
        const spine: PIXI.spine.Spine = new PIXI.spine.Spine(DevilsCrossRoad.assetLoader.getSpineAsset(spineName));
        spine.position.set(360, 360);
        spine.name = "BIGWIN_LEVEL_" + level;
        this.addChild(spine);
        spine.visible = false;
        return spine;
    }

    private resetBigwinAnim(): void {
        for (let i: number = 1; i <= 5; i++) {
            let resetBWSpine: PIXI.spine.Spine | undefined = this._bigwinSpineMap.get(i);
            if (resetBWSpine) {
                resetBWSpine.state.clearTracks();
                resetBWSpine.skeleton.setToSetupPose();
                resetBWSpine.skeleton.setSlotsToSetupPose();
            }
        }
    }

    private createOverlay(): void {
        this._overlay = new PIXI.Graphics();
        this._overlay.visible = false;
        this.setOverlayProps();
        this.addChild(this._overlay);
    }

    private onResize(): void {
        this.setOverlayProps();
    }

    private setOverlayProps(): void {
        const bounds = NolimitApplication.screenBounds;
        this._overlay.clear();
        this._overlay.beginFill(0x000000, 0.75);
        this._overlay.drawRect(bounds.left, bounds.top, bounds.width, bounds.height);
        this._overlay.endFill();
    }
}